import { useState } from "react";

/**
 * Hook to manage URL selection state for bulk actions.
 * @param {Array} urlList - The current list of URL objects
 */
const useUrlBulkActions = (urlList) => {
  const [selectedUrls, setSelectedUrls] = useState([]);

  const handleCheckboxClick = (_, id) =>
    setSelectedUrls((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const handleSelectAllClick = (e) =>
    setSelectedUrls(e.target.checked ? (urlList?.map((u) => u.id) || []) : []);

  const allSelected = urlList.length > 0 && selectedUrls.length === urlList.length;
  const someSelected = selectedUrls.length > 0 && selectedUrls.length < urlList.length;

  return {
    selectedUrls,
    setSelectedUrls,
    handleCheckboxClick,
    handleSelectAllClick,
    allSelected,
    someSelected,
  };
};

export default useUrlBulkActions;
